import { Button, DialogV2, Loader } from '@recruit-robin/robin-theme/web-components';

import { useDictionary } from '@/shared/lib/i18n';
import { useStyles } from './Footer.styles';

type FooterProps = {
  hasSelection: boolean;
  onConfirm: () => void;
  isSaving: boolean;
  footer?: React.ReactNode;
};

export const Footer = ({ hasSelection, onConfirm, isSaving, footer }: FooterProps) => {
  const classes = useStyles();
  const dictionary = useDictionary();

  return (
    <DialogV2.Footer>
      {footer}

      <Button
        customCss={classes.button}
        label={dictionary.continue}
        style="filled"
        type="highlight"
        onClick={onConfirm}
        disabled={!hasSelection}
        startIcon={isSaving && <Loader customCss={classes.loader} size={16} variant="ring-4" animateEntrance />}
      />
    </DialogV2.Footer>
  );
};
